// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"style__modalTitle__1cVYS","buttonWrapper":"style__buttonWrapper__2bs8d"};